import withModerationStatusDetails from './withModerationStatusDetails'
import Badge from 'components/FileDetailModerationBadge'

export default withModerationStatusDetails(Badge)
